(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tdw-dispatch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tdw-dispatch')) {
    customElements.define('tdw-dispatch', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController || this.initializationObserver) return;
        if (!this.initialize()) {
          this.initializationObserver = new MutationObserver(() => {
            if (this.initialize()) {
              this.initializationObserver.disconnect();
              this.initializationObserver = null;
            }
          });
          this.initializationObserver.observe(this, { childList: true, subtree: true });
        }
      }
      initialize() {
        if (!this.isConnected || this.abortController) return Boolean(this.abortController);
        this.rail = this.querySelector('.tdw-dispatch__rail');
        this.slides = Array.from(this.querySelectorAll('.tdw-dispatch__slide'));
        this.previous = this.querySelector('[data-dispatch-previous]');
        this.next = this.querySelector('[data-dispatch-next]');
        this.position = this.querySelector('.tdw-dispatch__position');
        this.controls = this.querySelector('.tdw-dispatch__controls');
        if (!this.rail || !this.slides.length || !this.previous || !this.next || !this.position || !this.controls) return false;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.positionTemplate = this.position.dataset.positionTemplate;
        this.update = this.update.bind(this);
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.rail.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(this.update);
        }, { passive: true, signal });
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.rail);
        this.update();
        return true;
      }
      move(direction) {
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        const step = this.slides[0].getBoundingClientRect().width + gap;
        if (step <= 0) return;
        const target = Math.round(this.rail.scrollLeft / step) + direction;
        this.rail.scrollTo({ left: Math.max(0, Math.min(target * step, this.rail.scrollWidth - this.rail.clientWidth)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        if (!this.isConnected || !this.abortController || !this.slides.length) return;
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        this.controls.hidden = max < 2;
        const left = this.rail.scrollLeft;
        this.previous.disabled = left < 2;
        this.next.disabled = left >= max - 2;
        const step = this.slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.rail).columnGap) || 0);
        const current = step > 0 ? Math.max(1, Math.min(this.slides.length, Math.round(left / step) + 1)) : 1;
        this.position.textContent = this.positionTemplate.replace('__CURRENT__', String(current));
      }
      disconnectedCallback() {
        this.initializationObserver?.disconnect();
        this.initializationObserver = null;
        this.abortController?.abort();
        this.abortController = null;
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tdw-event-atmosphere"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){
  const button=e.target.closest('[data-tdw-atmosphere-prev],[data-tdw-atmosphere-next]');
  if(!button)return;
  const section=button.closest('.tdw-event--gallery');
  const track=section&&section.querySelector('[data-tdw-atmosphere-track]');
  if(!track)return;
  const cards=track.querySelectorAll('.tdw-event__atmosphere-card');
  if(!cards.length)return;
  const step=cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:cards[0].getBoundingClientRect().width;
  const sign=button.matches('[data-tdw-atmosphere-prev]')?-1:1;
  track.scrollBy({left:step*sign,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
});
document.addEventListener('scroll',function(e){
  const track=e.target;
  if(!track?.matches?.('[data-tdw-atmosphere-track]'))return;
  const cards=track.querySelectorAll('.tdw-event__atmosphere-card');
  if(!cards.length)return;
  const step=cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:cards[0].getBoundingClientRect().width;
  const index=Math.min(cards.length,Math.max(1,Math.round(track.scrollLeft/Math.max(step,1))+1));
  const counter=track.closest('.tdw-event--gallery')?.querySelector('[data-tdw-atmosphere-counter]');
  if(counter)counter.textContent=index+' / '+cards.length;
},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tdw-event-landing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const swatch=event.target.closest('[data-tdw-event-swatch]');
  if(!swatch||swatch.disabled)return;
  const picker=swatch.closest('.tdw-event__product-form')?.querySelector('[data-tdw-event-variant]');
  if(!picker)return;
  picker.value=swatch.dataset.variantId;
  picker.dispatchEvent(new Event('change',{bubbles:true}));
});
document.addEventListener('change',function(event){
  const picker=event.target.closest('[data-tdw-event-variant]');
  if(!picker)return;
  const section=picker.closest('.tdw-event');
  const selected=picker.options[picker.selectedIndex];
  const price=selected?selected.dataset.price:'';
  const top=section.querySelector('[data-tdw-event-price]');
  const mobile=section.querySelector('[data-tdw-event-mobile-price]');
  if(top)top.textContent=price;
  if(mobile)mobile.textContent=price;
  section.querySelectorAll('[data-tdw-event-swatch]').forEach(function(button){
    const selected=button.dataset.variantId===picker.value;
    button.classList.toggle('is-selected',selected);
    button.setAttribute('aria-pressed',String(selected));
  });
});
document.addEventListener('click',function(e){
  const link=e.target.closest('.tdw-event__closing-button,.tdw-event__mobile-bar a');
  if(!link)return;
  const anchor=link.getAttribute('href');
  if(!anchor||anchor[0]!=='#')return;
  const target=document.getElementById(anchor.slice(1));
  if(!target)return;
  e.preventDefault();
  target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
});
document.addEventListener('click',function(e){
  const button=e.target.closest('.tdw-event__experience-button');
  if(!button)return;
  const destination=button.getAttribute('href');
  if(!destination||destination[0]!=='#')return;
  const heading=document.getElementById(destination.slice(1));
  if(!heading)return;
  const details=heading.closest('.tdw-event__workshop-details');
  if(details){
    const panel=details.querySelector('.tdw-event__full-details');
    if(panel)panel.open=true;
  }
  e.preventDefault();
  heading.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tdw-instagram-hub"] && !Shopify.designMode) return;
  try {
    
  function initTdwHappyPeople(root) {
    root.querySelectorAll('.tdw-social-hub__people:not([data-happy-ready])').forEach(function (carousel) {
      carousel.setAttribute('data-happy-ready', '1');
      var track = carousel.querySelector('.tdw-social-hub__people-track');
      if (!track) return;
      carousel.addEventListener('click', function (event) {
        var button = event.target.closest('[data-tdw-dir]');
        if (!button) return;
        var first = track.querySelector('.tdw-social-hub__person');
        if (!first) return;
        var distance = first.getBoundingClientRect().width + 11;
        var direction = button.getAttribute('data-tdw-dir') === 'prev' ? -1 : 1;
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollBy({ left: distance * direction, behavior: prefersReducedMotion ? 'instant' : 'smooth' });
      });
    });
  }
  initTdwHappyPeople(document);
  document.addEventListener('shopify:section:load', function (event) { initTdwHappyPeople(event.target); });

  } catch(e) { console.error(e); }
})();
})();
